module.exports = "/images/incepto.png?ec9dbf2977d1c0c3bb480898883c8d27";